import { Navigate, Route, Routes } from 'react-router-dom';
import Page404 from '../user/Auth/Page404';
import RetentionLayout from './RetentionLayout';
import Home from './tabs/Home';
import Onboarding from './tabs/Onboarding';
import Demo from './tabs/Demo';
import Tracking from './tabs/Tracking';
import Timeline from './tabs/Timeline';
import TodayTasks from './lists/TodayTasks';
import RetentionReports from './lists/RetentionReports';
import RetainedStudents from './lists/RetainedStudents';
import ExitedStudents from './lists/ExitedStudents';
import RetentionThemeProvider from './theme/RetentionThemeProvider';

// Mounted at /student-journey/* in MainRouter, inside DashboardLayout, with the retention-only theme (theme/retentionTheme.js). The sidebar's Retention group
// (roleSlice ensureRetentionAutoTabs) has path /student-journey, so it stays open on the lists and
// inside a student's workspace alike.
// TODO(access): 404 unless the caller is the assigned CRO, their reporting head or a CRM,
// once /retention/:id/header returns the owner (RETENTION_WORKFLOW.md §2.2, §6.0).
export default function RetentionRouter() {
  return (
    <RetentionThemeProvider>
    <Routes>
      {/* CRO-wide lists (§2.4). Static segments rank above :courseEnrollmentId. */}
      <Route index element={<Navigate to="tasks" replace />} />
      <Route path="tasks" element={<TodayTasks />} />
      <Route path="reports" element={<RetentionReports />} />
      <Route path="retained" element={<RetainedStudents />} />
      <Route path="exited" element={<ExitedStudents />} />

      {/* Per-student workspace */}
      <Route path=":courseEnrollmentId" element={<RetentionLayout />}>
        <Route index element={<Home />} />
        <Route path="onboarding" element={<Onboarding />} />
        <Route path="demo" element={<Demo />} />
        <Route path="tracking" element={<Tracking />} />
        <Route path="timeline" element={<Timeline />} />
      </Route>
      <Route path="*" element={<Page404 />} />
    </Routes>
    </RetentionThemeProvider>
  );
}
